import EmployerDetailsStep from '@/views/dashboard/form101/steps/EmployerDetailsStep.component.vue';
import PersonalDetailsStep from '@/views/dashboard/form101/steps/personal/PersonalDetailsStep.component.vue';
import ChildrenDetailsStep from '@/views/dashboard/form101/steps/ChildrenDetailsStep.component.vue';
import IncomeDetailsStep from '@/views/dashboard/form101/steps/IncomeDetailsStep.component.vue';
import TaxDetailsStep from '@/views/dashboard/form101/steps/TaxDetailsStep.component.vue';
import DocumentsAndDeclarationStep from '@/views/dashboard/form101/steps/DocumentsAndDeclarationStep.component.vue';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Action, Getter, Mutation } from 'vuex-class';
import WizardConfirmDialog from './steps/WizardConfirmDialog.component';
import { Component, Inject, Vue } from 'vue-property-decorator';
import {
  APPROVE_DETAILS_CHANGES,
  CHECK_MISSING_DOCUMENTS,
  COMPARE_EMPLOYEE_DETAILS,
  FORM101_DATA,
  FORM101_ID,
  FORM101_META_DATA,
  FORM_ERRORS,
  FORM_READ_ONLY_MODE,
  FORM_REJECTED_REASON,
  FORM_ROOT,
  FORM_SUCCESS_DIALOG,
  GENERATE_FORM_101_AS_PDF,
  GET_FORM101_AS_PDF,
  GET_FORM101_DATA,
  OPEN_DELETE_FORM_MODAL,
  OPEN_CONFIRM_FORM_DIALOG,
  OPEN_SAVE_BEFORE_LEAVE_WIZARD_MODAL,
  SAVE_AS_DRAFT,
  SET_FORM101_DATA,
  SET_FORM_ERRORS,
  SET_FORM_ERRORS_SHOW,
  SET_FORM_LOADING_MODE,
  SET_FORM_READ_ONLY_MODE,
  SET_FORM_REJECTED_REASON,
  SET_FORM_SUCCESS_DIALOG,
  SET_OPEN_DELETE_FORM_DIALOG,
  SET_OPEN_CONFIRM_FORM_DIALOG,
  SET_OPEN_FORM_101_CHANGES_DIALOG,
  SET_OPEN_FORM_STATUS_HISTORY_DIALOG,
  SET_OPEN_REJECT_FORM_DIALOG,
  SET_OPEN_SAVE_BEFORE_LEAVE_WIZARD_MODAL,
  SET_SAVE_BEFORE_LEAVE_WIZARD_ROUTE_NAME,
  SET_TOOLTIP_ID,
  SUBMIT_FORM,
  DELETE_FORM_WITH_CHANGES,
  SKIP_SAVE_BEFORE_LEAVE_WIZARD_MODAL,
  DELETE_FORM_ERRORS,
  SET_OPEN_APPROVE_FORM_DIALOG,
} from '@/types/form.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import {
  DELETE_DOCUMENT,
  GET_DOCUMENT_LIST, LOADING,
  MISSING_DOCUMENTS,
  REMOVE_MISSING_DOCUMENT_FLAG, SET_LOADING,
  SET_MISSING_DOCUMENTS,
  SET_REMOVE_MISSING_DOCUMENT_FLAG,
  SET_UPLOAD_MISSING_DOCUMENT_FLAG,
} from '@/types/documents.types';
import { InputFile } from '@/models/InputFile.model';
import SidebarErrors from '@/components/sidebar-errors/SidebarErrors.component';
import { WizardFormErrors } from '@/models/form/WizardFormError';
import $ from 'jquery';
import { Documents } from '@/models/form/Documents.model';
import { eventsHub } from '@/main';
import SaveBeforeLeaveWizardModal from '@/components/modals/SaveBeforeLeaveWizard.modal.vue';
import ApproveFormModal from '@/components/modals/ApproveForm.modal.vue';
import RejectFormModal from '@/components/modals/RejectForm.modal.vue';
import {
  CAN_APPROVE,
  CAN_REJECT,
  FORMS_RESULT_DATA,
  GET_FORM_101_CHANGES,
  GET_FORM_101_REJECT_REASON,
  GET_FORM_STATUS_HISTORY_LIST,
  GET_MANAGER_DOCUMENT_LIST,
  MANAGER_GENERATE_FORM_101_AS_PDF,
  MANAGER_GET_FORM_101_AS_PDF,
  MANAGER_MODE,
  MANAGER_ROOT,
  SET_APPROVE_FORM_ERRORS,
  SET_FORM_101_CHANGES_NOTES_ERRORS,
  SET_FORM_101_REJECT_REASON,
  SET_MANAGER_MODE,
  SET_REJECT_FORM_ERRORS,
  STATUS_DESC,
} from '@/types/managerForm.types';
import FormStatusHistoryModal from '@/components/modals/FormStatusHistory.modal.vue';
import Form101ChangesModal from '@/components/modals/Form101Changes.modal.vue';
import { Grid } from '@/models/Grid.model';
import { GOV, USER_DETAILS } from '@/types/authentication.types';
import { UserDetails } from '@/models/UserDetails.model';
import { Form101StatusEnum } from '@/models/FormStatus.enum';
import { Form101MetaData } from '@/models/form/Form101MetaData.model';

@Component({
  components: {
    EmployerDetailsStep,
    PersonalDetailsStep,
    ChildrenDetailsStep,
    IncomeDetailsStep,
    TaxDetailsStep,
    DocumentsAndDeclarationStep,
    WizardConfirmDialog,
    SidebarErrors,
    SaveBeforeLeaveWizardModal,
    ApproveFormModal,
    RejectFormModal,
    FormStatusHistoryModal,
    Form101ChangesModal,
  },
  beforeRouteLeave: (to, from, next) => {
    const isOpenSaveBeforeLeaveWizardModal = eventsHub.$store.getters[FORM_ROOT + OPEN_SAVE_BEFORE_LEAVE_WIZARD_MODAL];
    const formIsReadOnlyMode = eventsHub.$store.getters[FORM_ROOT + FORM_READ_ONLY_MODE];
    const formIsManagerMode = eventsHub.$store.getters[MANAGER_ROOT + MANAGER_MODE];
    const formSuccessDialog = eventsHub.$store.getters[FORM_ROOT + FORM_SUCCESS_DIALOG];
    const skipSaveBeforeLeaveWizardModal = eventsHub.$store.getters[FORM_ROOT + SKIP_SAVE_BEFORE_LEAVE_WIZARD_MODAL];
    if (to.matched.some((record: any) => record.meta.authNotRequired)) {
      next();
    } else if (!formIsReadOnlyMode && from.name === 'wizard' && !isOpenSaveBeforeLeaveWizardModal && !formIsManagerMode
      && !formSuccessDialog && !skipSaveBeforeLeaveWizardModal) {
      eventsHub.$store.commit(FORM_ROOT + SET_OPEN_SAVE_BEFORE_LEAVE_WIZARD_MODAL,
        true, { root: true });
      eventsHub.$store.commit(FORM_ROOT + SET_SAVE_BEFORE_LEAVE_WIZARD_ROUTE_NAME,
        to.name, { root: true });
    } else {
      next();
      eventsHub.$store.commit(FORM_ROOT + SET_OPEN_SAVE_BEFORE_LEAVE_WIZARD_MODAL, false, { root: true });
      eventsHub.$store.commit(FORM_ROOT + SET_FORM_READ_ONLY_MODE, false, { root: true });
      eventsHub.$store.commit(MANAGER_ROOT + SET_MANAGER_MODE, false, { root: true });
    }
  },
})
export default class Form101WizardComponent extends Vue {

  @Inject() public $validator;

  @Action(GET_DOCUMENT_LIST, StoreNamespace.DOCUMENT) public getDocumentList;
  @Action(GET_MANAGER_DOCUMENT_LIST, StoreNamespace.MANAGER) public getManagerDocumentList;
  @Action(DELETE_DOCUMENT, StoreNamespace.DOCUMENT) public deleteDocument;
  @Action(GET_FORM101_DATA, StoreNamespace.FORM) public getForm101Data;
  @Action(SUBMIT_FORM, StoreNamespace.FORM) public submitForm;
  @Action(SAVE_AS_DRAFT, StoreNamespace.FORM) public saveAsDraft;
  @Action(CHECK_MISSING_DOCUMENTS, StoreNamespace.FORM) public checkMissingDocuments;
  @Action(GET_FORM_101_CHANGES, StoreNamespace.MANAGER) public getForm101Changes;
  @Action(GET_FORM_STATUS_HISTORY_LIST, StoreNamespace.MANAGER) public getFormStatusHistoryList;
  @Action(MANAGER_GET_FORM_101_AS_PDF, StoreNamespace.MANAGER) public managerGetForm101AsPdf;
  @Action(MANAGER_GENERATE_FORM_101_AS_PDF, StoreNamespace.MANAGER) public managerGenerateForm101AsPdf;
  @Action(GET_FORM101_AS_PDF, StoreNamespace.FORM) public getForm101AsPdf;
  @Action(GENERATE_FORM_101_AS_PDF, StoreNamespace.FORM) public generateForm101AsPdf;
  @Action(GET_FORM_101_REJECT_REASON, StoreNamespace.MANAGER) public getForm101RejectReason;
  @Action(COMPARE_EMPLOYEE_DETAILS, StoreNamespace.FORM) public compareEmployeeDetails;
  @Action(DELETE_FORM_WITH_CHANGES, StoreNamespace.FORM) public deleteFormWithChanges;

  @Mutation(SET_FORM_ERRORS, StoreNamespace.FORM) public setFormErrors;
  @Mutation(SET_OPEN_CONFIRM_FORM_DIALOG, StoreNamespace.FORM) public setOpenConfirmFormDialog;
  @Mutation(SET_OPEN_APPROVE_FORM_DIALOG, StoreNamespace.FORM) public setOpenApproveFormDialog;
  @Mutation(SET_OPEN_REJECT_FORM_DIALOG, StoreNamespace.FORM) public setOpenRejectFormDialog;
  @Mutation(SET_FORM_SUCCESS_DIALOG, StoreNamespace.FORM) public setFormSuccessDialog;
  @Mutation(SET_TOOLTIP_ID, StoreNamespace.FORM) public setTooltipId;
  @Mutation(SET_REMOVE_MISSING_DOCUMENT_FLAG, StoreNamespace.DOCUMENT) public setRemoveMissingDocumentsFlag;
  @Mutation(SET_MISSING_DOCUMENTS, StoreNamespace.DOCUMENT) public setMissingDocuments;
  @Mutation(SET_UPLOAD_MISSING_DOCUMENT_FLAG, StoreNamespace.DOCUMENT) public setUploadMissingDocumentsFlag;
  @Mutation(SET_OPEN_FORM_STATUS_HISTORY_DIALOG, StoreNamespace.FORM) public setOpenFormStatusHistoryDialog;
  @Mutation(SET_OPEN_FORM_101_CHANGES_DIALOG, StoreNamespace.FORM) public setOpenForm101ChangesDialog;
  @Mutation(SET_FORM_REJECTED_REASON, StoreNamespace.FORM) public setFormRejectedReason;
  @Mutation(SET_FORM_101_REJECT_REASON, StoreNamespace.MANAGER) public setForm101RejectedReason;
  @Mutation(SET_APPROVE_FORM_ERRORS, StoreNamespace.MANAGER) public setApproveFormErrors;
  @Mutation(SET_REJECT_FORM_ERRORS, StoreNamespace.MANAGER) public setRejectFormErrors;
  @Mutation(SET_FORM_101_CHANGES_NOTES_ERRORS, StoreNamespace.MANAGER) public setForm101ChangesNotesErrors;
  @Mutation(SET_FORM_ERRORS_SHOW, StoreNamespace.FORM) public setFormErrorsShow;
  @Mutation(SET_FORM101_DATA, StoreNamespace.FORM) public resetFormData;
  @Mutation(SET_FORM_LOADING_MODE, StoreNamespace.FORM) public setFormLoadingMode;
  @Mutation(SET_LOADING, StoreNamespace.DOCUMENT) public setDocLoading;
  @Mutation(SET_OPEN_DELETE_FORM_DIALOG, StoreNamespace.FORM) public setOpenDeleteFormDialog;

  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(FORM101_META_DATA, StoreNamespace.FORM) public form101MetaData!: Form101MetaData;
  @Getter(MANAGER_MODE, StoreNamespace.MANAGER) public managerMode!: boolean;
  @Getter(FORM101_ID, StoreNamespace.FORM) public formId!: Form101DataModel;
  @Getter(FORM_ERRORS, StoreNamespace.FORM) public formErrors!: WizardFormErrors;
  @Getter(OPEN_CONFIRM_FORM_DIALOG, StoreNamespace.FORM) public openConfirmFormDialog!: boolean;
  @Getter(FORM_SUCCESS_DIALOG, StoreNamespace.FORM) public formSuccessDialog!: boolean;
  @Getter(FORM_READ_ONLY_MODE, StoreNamespace.FORM) public formReadOnlyMode!: boolean;
  @Getter(FORM_REJECTED_REASON, StoreNamespace.FORM) public formRejectedReason!: string;
  @Getter(REMOVE_MISSING_DOCUMENT_FLAG, StoreNamespace.DOCUMENT) public removeMissingDocumentsFlag!: boolean;
  @Getter(MISSING_DOCUMENTS, StoreNamespace.DOCUMENT) public missingDocuments!: Documents[];
  @Getter(CAN_APPROVE, StoreNamespace.MANAGER) public canApprove!: boolean;
  @Getter(CAN_REJECT, StoreNamespace.MANAGER) public canReject!: boolean;
  @Getter(STATUS_DESC, StoreNamespace.MANAGER) public statusDesc!: string;
  @Getter(FORMS_RESULT_DATA, StoreNamespace.MANAGER) public formsResultData!: Grid;
  @Getter(USER_DETAILS, StoreNamespace.AUTHENTICATION) public userDetails!: UserDetails;
  @Getter(GOV, StoreNamespace.AUTHENTICATION) public gov!: string;
  @Getter(LOADING, StoreNamespace.DOCUMENT) public docLoading!: boolean;
  @Getter(OPEN_DELETE_FORM_MODAL, StoreNamespace.FORM) public openDeleteFormModal!: boolean;
  @Getter(APPROVE_DETAILS_CHANGES, StoreNamespace.FORM) public approveDetailsChanges!: boolean;
  @Getter(DELETE_FORM_ERRORS, StoreNamespace.FORM) public deleteFormErrors!: string[];

  private deleteFileModal: boolean = false;
  private approveModal: boolean = false;
  private formRejectedReasonDialog: boolean = false;
  private fileToDelete: InputFile | null = null;
  private MISSING_DOCUMENTS_STAGE_NUMBER: number = 5;
  private STAGE_NUMBER: number = 0;

  public created() {
    const element = document.getElementsByTagName('BODY')[0];
    element.classList.add('is-wizard-on');
    element.classList.add('employer-details-step');
    this.setOpenConfirmFormDialog(false);
    this.setFormErrors(null);
    this.setFormErrorsShow(false);
    this.setOpenDeleteFormDialog(false);
    if (!this.formReadOnlyMode && !this.managerMode) {
      this.compareEmployeeDetails(this.form101Data.formId);
    }
    if (this.managerMode) {
      this.getManagerDocumentList({
        requestBody: {
          formId: this.form101Data.formId,
          officeNum: this.form101Data.officeNum,
          idNum: this.form101Data.idNum,
          positionNum: this.form101Data.positionNum,
        },
      });
    } else if ('' + this.formId) {
      this.getDocumentList(this.formId);
    }
    if (!this.form101Data.formId) {
      const loginRouting = this.gov ? 'login?c=gov' : 'login';
      this.$router.push({ path: loginRouting });
    } else {
      this.$root.$on('openDeleteFileDialog', this.openDeleteFileDialog);
    }
  }

  public mounted() {
    if (this.form101Data.formId) {
      if (this.managerMode) {
        if (this.form101Data.formStatus && this.form101Data.formStatus === 15) {
          this.getForm101RejectReason({
            formId: this.form101Data.formId,
            officeNum: this.form101Data.officeNum,
            idNum: this.form101Data.idNum,
            positionNum: this.form101Data.positionNum,
          });
        }
        this.getFormStatusHistoryList({
          formId: this.form101Data.formId,
          officeNum: this.form101Data.officeNum,
          idNum: this.form101Data.idNum,
          positionNum: this.form101Data.positionNum,
        });
        this.getManagerDocumentList({
          requestBody: {
            formId: this.form101Data.formId,
            officeNum: this.form101Data.officeNum,
            idNum: this.form101Data.idNum,
            positionNum: this.form101Data.positionNum,
          },
        });
      } else {
        this.getDocumentList(this.form101Data.formId);
        this.setOpenDeleteFormDialog(false);
      }
      this.setFormSuccessDialog(false);
      this.setFormLoadingMode(false);
    }
  }

  public beforeDestroy() {
    const element = document.getElementsByTagName('BODY')[0];
    element.classList.remove('is-wizard-on');
    this.setFormRejectedReason('');
    this.setForm101RejectedReason('');
  }

  public destroyed() {
    this.resetFormData({});
    this.setOpenConfirmFormDialog(false);
    this.setOpenApproveFormDialog(false);
    this.setOpenRejectFormDialog(false);
    this.setOpenForm101ChangesDialog(false);
    this.setOpenDeleteFormDialog(false);
    this.deleteFormErrors.length = 0;
  }


  public onTabChanged(prevIndex: number, nextIndex: number): void {
    this.setTooltipId('');
    this.STAGE_NUMBER = nextIndex;
    const element = document.getElementsByTagName('BODY')[0];
    element.classList.remove('personal-details-step');
    element.classList.remove('children-details-step');
    element.classList.remove('documents-declaration-step');
    element.classList.remove('employer-details-step');
    element.classList.remove('income-details-step');
    element.classList.remove('tax-details-step');
    switch (this.STAGE_NUMBER) {
      case 0:
        element.classList.add('employer-details-step');
        break;
      case 1:
        element.classList.add('personal-details-step');
        break;
      case 2:
        element.classList.add('children-details-step');
        break;
      case 3:
        element.classList.add('income-details-step');
        break;
      case 4:
        element.classList.add('tax-details-step');
        break;
      case 5:
        element.classList.add('documents-declaration-step');
        break;
    }
    if (this.MISSING_DOCUMENTS_STAGE_NUMBER === nextIndex) {
      this.setUploadMissingDocumentsFlag(true);
      this.setMissingDocuments([]);
      if (!this.formReadOnlyMode) {
        this.checkMissingDocuments()
          .then((data) => data)
          .catch(err => err);
      }
    } else {
      this.setUploadMissingDocumentsFlag(false);
    }
    window.scrollTo(0, 0);
    // do something on tab change
  }

  public onComplete(success: boolean, data?: any) {
    this.$validator.validateAll('payrollDeclarationForm').then((isValid: any) => {
      if (!isValid) {
        document.getElementById('declarationContent')!.focus();
        return;
      }
      this.$validator.validateAll('payrollForm').then((result: any) => {
        if (!result) {
          this.clientErrorFocus();
          return;
        }
        if (this.userDetails.loginFromSso) {
          this.submitForm({
            password: null,
            effectiveDate: this.form101Data.effectiveDate ? this.form101Data.effectiveDate : null,
          });
        } else {
          this.saveAsDraft(true);
        }
      });
    });
    // do something on complete
  }

  public onSubmitForm() {
    this.submitForm(this.form101Data);
  }

  public openDeleteFileDialog(file: InputFile) {
    this.deleteFileModal = true;
    this.fileToDelete = file;
  }

  public closeDeleteDialog() {
    this.deleteFileModal = false;
    this.fileToDelete = null;
    if (this.removeMissingDocumentsFlag) {
      this.setRemoveMissingDocumentsFlag(false);
    }
  }

  public onRemovedClicked() {
    if (this.fileToDelete) {
      this.deleteDocument(this.fileToDelete.docId);
      this.deleteFileModal = false;
      this.fileToDelete = null;
    }
  }

  public onSaveClicked() {
    this.$validator.validateAll('payrollForm').then((result: any) => {
      if (!result) {
        this.clientErrorFocus();
        return;
      }
      this.saveAsDraft();
    });
  }

  public openApproveDialog() {
    this.approveModal = true;
  }

  public closeApproveDialog() {
    this.approveModal = false;
  }

  public onApproveClicked() {
    this.setApproveFormErrors([]);
    this.setOpenApproveFormDialog(true);
  }

  public onRejectClicked() {
    this.setRejectFormErrors([]);
    this.getForm101RejectReason({
      formId: this.form101Data.formId,
      officeNum: this.form101Data.officeNum,
      idNum: this.form101Data.idNum,
      positionNum: this.form101Data.positionNum,
    });
    this.setOpenRejectFormDialog(true);
  }

  public onDownloadPDFClicked() {
    if (this.form101Data.formStatus === Form101StatusEnum.READY_FOR_SIGNING ||
      this.form101Data.formStatus === Form101StatusEnum.SEND_FOR_SIGNING ||
      this.form101Data.formStatus === Form101StatusEnum.SIGNED ||
      this.form101Data.formStatus === Form101StatusEnum.UPDATE_IPT_COMPLETE) {
      this.getForm101AsPdf(this.form101Data.docId);
    } else {
      this.generateForm101AsPdf(this.form101Data.formId);
    }
  }

  public onManagerDownloadPDFClicked() {
    if (this.form101Data.formStatus === Form101StatusEnum.READY_FOR_SIGNING ||
      this.form101Data.formStatus === Form101StatusEnum.SEND_FOR_SIGNING ||
      this.form101Data.formStatus === Form101StatusEnum.SIGNED ||
      this.form101Data.formStatus === Form101StatusEnum.UPDATE_IPT_COMPLETE) {
      this.managerGetForm101AsPdf({
        idNum: this.form101Data.idNum,
        officeNum: this.form101Data.officeNum,
        positionNum: this.form101Data.positionNum,
        docId: this.form101Data.docId,
      });
    } else {
      this.managerGenerateForm101AsPdf({
        idNum: this.form101Data.idNum,
        officeNum: this.form101Data.officeNum,
        positionNum: this.form101Data.positionNum,
        formId: this.form101Data.formId,
      });
    }
  }

  public onStatusHistoryClicked() {
    this.getFormStatusHistoryList({
      formId: this.form101Data.formId,
      officeNum: this.form101Data.officeNum,
      idNum: this.form101Data.idNum,
      positionNum: this.form101Data.positionNum,
    });
    this.setOpenFormStatusHistoryDialog(true);
  }

  public onForm101ChangesClicked() {
    this.setForm101ChangesNotesErrors([]);
    this.getForm101Changes({
      formId: this.form101Data.formId,
      officeNum: this.form101Data.officeNum,
      idNum: this.form101Data.idNum,
      positionNum: this.form101Data.positionNum,
      openForm101ChangesDialog: true,
    });
  }

  public moveToStep(index: number): void {
    this.$validator.validateAll('payrollForm').then((result: any) => {
      if (!result) {
        this.clientErrorFocus();
      } else {
        (this.$refs.formWizard as any).changeTab(0, index);
      }
    });
  }

  public closeSuccessDialog(): void {
    this.setFormSuccessDialog(false);
    this.$router.push({ name: 'lobby' });
  }

  public closeFormRejectedReasonDialogDialog(): void {
    this.formRejectedReasonDialog = false;
  }

  public scrollAndFocus(key): void {
    const firstEl: HTMLElement = (document.getElementById(key) as HTMLHRElement);
    if (firstEl) {
      // add is error with color here if needed
      const element = document.querySelector('body');
      if (element!.classList.contains('scrolled')) {
        if (firstEl.outerHTML.includes('checkbox')) {
          $('html, body').animate({ scrollTop: $(firstEl.closest('.checkbox-widget')).offset().top - 210 }, 'slow');
        } else {
          $('html, body').animate({ scrollTop: $(firstEl).offset().top - 200 }, 'slow');
        }
      } else {
        if (firstEl.outerHTML.includes('checkbox')) {
          $('html, body').animate({ scrollTop: $(firstEl.closest('.checkbox-widget')).offset().top - 280 }, 'slow');
        } else {
          $('html, body').animate({ scrollTop: $(firstEl).offset().top - 280 }, 'slow');
        }
      }
      firstEl.focus();
    }
  }

  public sideErrorClicked(err): void {
    if (err.fieldKeys) {
      (this.$refs.formWizard as any).changeTab(0, Number(err.sectionNumber - 1));
      setTimeout(() => {
        for (const index of Object.keys(err.fieldKeys)) {
          let el: HTMLElement = (document.getElementById(err.fieldKeys[index]) as HTMLHRElement);
          if (!el) {
            el = (document.getElementById(err.fieldKeys[index] + index.toString()) as HTMLHRElement);
          }
          if (el) {
            const parent: any = el.closest('.form-field');
            if (parent) {
              parent.classList.add('is-error');
            }
          }
        }
        this.scrollAndFocus(err.fieldKeys[0]);
        const firstEl: HTMLElement = (document.getElementById(err.fieldKeys[0]) as HTMLHRElement);
        if (firstEl) {
          if (firstEl.outerHTML.includes('button')) {
            firstEl.classList.add('is-error');
          }
        }
      }, 500);
    }
  }

  public onViewClicked(key: string, sectionNumber: number): void {
    if (key) {
      (this.$refs.formWizard as any).changeTab(0, sectionNumber - 1);
      setTimeout(() => {
        this.scrollAndFocus(key);
      }, 500);
    }
  }

  private clientErrorFocus(): void {
    let firstInput: HTMLElement = document.querySelectorAll('input.is-error')[0] as HTMLElement;
    if (!firstInput) {
      const dropdown: HTMLElement = document.querySelectorAll('.dropdown.is-error')[0] as HTMLElement;
      if (dropdown) {
        firstInput = document.querySelectorAll('.dropdown.is-error input')[0] as HTMLElement;
      }
    }
    const section = firstInput.getAttribute('data-attribute');
    if (section) {
      (this.$refs.formWizard as any).changeTab(0, Number(section));
    }
    setTimeout(() => {
      this.scrollAndFocus(firstInput.id);
    });
  }

  private removeErrors(): void {
    const elements = document.getElementsByClassName('is-error');
    while (elements.length > 0) {
      elements[0].classList.remove('is-error');
    }
  }

  public showEffectiveDate(): boolean {
    return this.form101Data.revision !== 1 && this.form101Data.effectiveDate != null;
  }

  private onApproveDeleteForm() {
    this.deleteFormWithChanges(this.form101Data.formId);
  }

  private closeModal() {
    this.deleteFormErrors.length = 0
    this.setOpenDeleteFormDialog(false);
  }


}
